import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useData } from "../data/DataContext";


export const Seo = ({ title, description, keywords = [], image, type = "website", schema }) => {
  const { pathname } = useLocation();
  const { favicon, settings } = useData();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${pathname}`;
  const img = image ? `${origin}${image}` : `${origin}${settings.logo || "/images/games/maha-games-logo-w512.webp"}`;
  return (
    <Helmet defaultTitle="Maha Games Apps">
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta property="og:site_name" content={settings.siteName} />
      {favicon && <link rel="icon" href={favicon} />}
      {settings.googleVerification && <meta name="google-site-verification" content={settings.googleVerification} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")}</script>}
    </Helmet>
  );
};

export default Seo;
